import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  utilityId: 1,
  applicationTypeId: 3,
  consumerNumber: "",
  customerDetail: {
    id: 0,
    customerNumber: "",
    customerName: "",
  },
  applicant: {
    id: 0,
    applicantTypeId: "",
    applicantName: "",
    panNumber: "",
    gstNumber: "",
    occupancyTypeId: "",
    addressType: "",
    correspondenceAddress: "",
    city: "",
    pinCode: "",
    email: "",
    mobileNumber: "",
    landLine: "",
    alternateEmail: "",
    alternateMobileNumber: "",
    eBillConfirmation: false,
  },
  authorizedPerson: {
    id: 0,
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    designation: "",
    email: "",
    mobileNumber: "",
    landLine: "",
  },
  connectionLoad: {
    id: 0,
    powerRequirement: "",
    loadDetails: "",
    supplyVoltage: "",
    tariffCategory: "",
    usagePurpose: "",
  },

  declaration: {
    declarationId: 0,
    consumerDuesOutstanding: "",
    premisesDuesOutstanding: "",
    firmDuesOutstanding: "",
  },
  parentId: "",
  documents: [],
  extraValues: {
    requiredDocumentsCount: 0,
    proofOfOwnershipTypes: [],
  },
  proofOfOwnershipDescription: "",
  isDraft: true,
};

const nameTransferConnectionSlice = createSlice({
  name: "nameTransferConnectionFormData",
  initialState,
  reducers: {
    setValues(_, action) {
      return action.payload;
    },
    resetValues() {
      return initialState;
    },
  },
});

export const { setValues, resetValues } = nameTransferConnectionSlice.actions;

export default nameTransferConnectionSlice.reducer;
